import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
    commissionPlanChangeWaitingPeriods: null,
    isNew: false,
    lastState: null,
    lastScope: null
};

const commissionPlanChangeWaitingPeriodReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.COMMISSIONPLANCHANGEWAITINGPERIOD_START: {
            return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
        }
        case actionTypes.COMMISSIONPLANCHANGEWAITINGPERIOD_SUCCESS: {
            return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
        }
        case actionTypes.COMMISSIONPLANCHANGEWAITINGPERIOD_FAIL: {
            return updateState(state, { lastState: constants.STATE_FAIL });
        }
        default: {
            return state;
        }
    }
};

export default commissionPlanChangeWaitingPeriodReducer;
